module.exports = __webpack_public_path__ + "media/images/new/icons/location-6eaf99bdc023f56c074fbdcb8ac08c0f.png";